// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"2facbeb3","70":"6cb0267e","71":"87959abf","195":"db8749ca","216":"72e72d30","293":"72c0937e","349":"aad7b08a","360":"804374f8","419":"0b94cc9e","606":"20b5474f","621":"ee625e38","832":"ec1064c9","870":"01ebb9e7"}[chunkId] + ".chunk.css";
};